import { createContext, useContext, useState, type ReactNode } from 'react';
import { INITIAL_SIGNUP_STATE, type SignupState } from './types';

interface SignupContextValue {
  state: SignupState;
  update: (patch: Partial<SignupState>) => void;
  reset: () => void;
}

const SignupContext = createContext<SignupContextValue | null>(null);

export function SignupProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<SignupState>(INITIAL_SIGNUP_STATE);

  const update = (patch: Partial<SignupState>) => {
    setState((prev) => ({ ...prev, ...patch }));
  };

  const reset = () => setState(INITIAL_SIGNUP_STATE);

  return (
    <SignupContext.Provider value={{ state, update, reset }}>
      {children}
    </SignupContext.Provider>
  );
}

export function useSignup() {
  const ctx = useContext(SignupContext);
  if (!ctx) throw new Error('useSignup must be used inside SignupProvider');
  return ctx;
}
